var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { id: "Icon/Fill/copy" } }, [
        _c(
          "mask",
          {
            staticStyle: { "mask-type": "alpha" },
            attrs: {
              id: _vm.maskId,
              maskUnits: "userSpaceOnUse",
              x: "2",
              y: "2",
              width: "14",
              height: "14"
            }
          },
          [
            _c("path", {
              attrs: {
                id: "Mask_2",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d:
                  "M6.75 9V9.75H4.25025C3.97425 9.75 3.75 9.52575 3.75 9.24975V4.25025C3.75 3.97425 3.97425 3.75 4.25025 3.75H9.24975C9.52575 3.75 9.75 3.97425 9.75 4.25025V6.75H9C7.7595 6.75 6.75 7.7595 6.75 9ZM13.5 6.75H11.25V4.25025C11.25 3.147 10.353 2.25 9.24975 2.25H4.25025C3.147 2.25 2.25 3.147 2.25 4.25025V9.24975C2.25 10.353 3.147 11.25 4.25025 11.25H6.75V13.5C6.75 14.7405 7.7595 15.75 9 15.75H13.5C14.7405 15.75 15.75 14.7405 15.75 13.5V9C15.75 7.7595 14.7405 6.75 13.5 6.75Z",
                fill: "white"
              }
            })
          ]
        ),
        _c("g", { attrs: { mask: "url(#" + _vm.maskId + ")" } }, [
          _c("g", { attrs: { id: "🎨 Color" } }, [
            _c("rect", {
              attrs: { id: "Base", width: "18", height: "18", fill: _vm.color }
            })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }